/* ==========================================================================
  grid.js

  Masonry grid for featured items.
========================================================================== */

function sol_set_bottom_margin() {
  var gutter = document.querySelector('.js-grid__gutter');
  var card_inners = document.querySelectorAll('.card');

  if (card_inners && gutter) {
    for (var i = card_inners.length - 1; i >= 0; i--) {
      card_inners[i].style.marginBottom = gutter.offsetWidth + 'px';
    }
  }
}
sol_set_bottom_margin();
window.addEventListener('resize', sol_set_bottom_margin, false);

function sol_is_old_ie() {

  var ua = window.navigator.userAgent;
  var msie = ua.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true;
  }
  return false;

}

var grid = document.querySelectorAll('.js-grid');
if (grid) {

  var msnry = [];

  for (var i = grid.length - 1; i >= 0; i--) {
    // init masonry
    msnry.push(new Masonry(grid[i], {
    itemSelector: '.card',
    columnWidth: '.js-grid__sizer',
    gutter: '.js-grid__gutter',
    percentPosition: true,
    maxColumnHeightDifference: 25 // @see: https://github.com/desandro/masonry/pull/811
    }));

    grid[i].classList.add('block--featured__grid--init');

  }

  window.onload = function(e){
    if (msnry) {
      for (var i = msnry.length - 1; i >= 0; i--) {
        // fix layout for IE11
        msnry[i].layout();
      }
    }
  };

  if (sol_is_old_ie()) {
    var times = 0;
    setInterval(function() {
      if (times < 5) {
        times++;
        sol_set_bottom_margin();
        if (msnry) {
          for (var i = msnry.length - 1; i >= 0; i--) {
            // fix layout for IE11
            msnry[i].layout();
          }
        }
      }
    }, 1500);
  }


}
